export const CUSTOM_QUOTE_SEQUENCE_LINKS = {
         category: {
           previous: ``,
           next: `/custom-quote/3d-printing/has-3dmodel/`,
         },
         has3DModel: {
           previous: `/custom-quote/3d-printing/category`,
           next: `/custom-quote/3d-printing/file-upload/`,
         },
         fileUpload: {
           previous: `/custom-quote/3d-printing/has-3dmodel/`,
           next: `/custom-quote/3d-printing/materials/`,
         },
         materials: {
           previous: `/custom-quote/3d-printing/file-upload/`,
           next: `/custom-quote/3d-printing/finishing/`,
         },
         finishing: {
           previous: `/custom-quote/3d-printing/materials/`,
           next: `/custom-quote/3d-printing/total-units/`,
         },
         totalUnits: {
           previous: `/custom-quote/3d-printing/finishing/`,
           next: `/custom-quote/3d-printing/deadline/`,
         },
         deadline: {
           previous: `/custom-quote/3d-printing/total-units/`,
           next: `/custom-quote/3d-printing/project-information/`,
         },
         projectInformation: {
           previous: `/custom-quote/3d-printing/deadline/`,
           next: `/custom-quote/3d-printing/contact-information/`,
         },
         contactInformation: {
           previous: `/custom-quote/3d-printing/project-information/`,
           next: ``,
         },
       }